import { create } from 'zustand';

interface Choice {
  nodeId: string;
  optionIndex: number;
  score: number;
  maxScore: number;
}

interface ScenarioState {
  moduleId: string | null;
  currentNodeId: string | null;
  choices: Choice[];
  showFeedback: boolean;
  lastChoiceIndex: number | null;
  isComplete: boolean;

  startScenario: (moduleId: string, startNodeId: string) => void;
  makeChoice: (nodeId: string, optionIndex: number, score: number, maxScore: number) => void;
  showFeedbackPanel: () => void;
  hideFeedback: () => void;
  advanceTo: (nodeId: string) => void;
  completeScenario: () => void;
  reset: () => void;
}

export const useScenarioStore = create<ScenarioState>()((set) => ({
  moduleId: null,
  currentNodeId: null,
  choices: [],
  showFeedback: false,
  lastChoiceIndex: null,
  isComplete: false,

  startScenario: (moduleId, startNodeId) =>
    set({
      moduleId,
      currentNodeId: startNodeId,
      choices: [],
      showFeedback: false,
      lastChoiceIndex: null,
      isComplete: false,
    }),

  makeChoice: (nodeId, optionIndex, score, maxScore) =>
    set((state) => ({
      choices: [...state.choices, { nodeId, optionIndex, score, maxScore }],
      lastChoiceIndex: optionIndex,
      showFeedback: true,
    })),

  showFeedbackPanel: () => set({ showFeedback: true }),
  hideFeedback: () => set({ showFeedback: false }),

  advanceTo: (nodeId) =>
    set({ currentNodeId: nodeId, showFeedback: false, lastChoiceIndex: null }),

  completeScenario: () => set({ isComplete: true }),
  reset: () =>
    set({
      moduleId: null,
      currentNodeId: null,
      choices: [],
      showFeedback: false,
      lastChoiceIndex: null,
      isComplete: false,
    }),
}));
